module.exports = "<div class=\"graph-box-wrapper\" data-ng-style=\"$ctrl.wrapperStyle\">\n    <div class=\"graph-box\">\n        <canvas  data-ng-style=\"$ctrl.boxStyle\" class=\"chart chart-line\" height=\"400\" width=\"450\" chart-options=\"$ctrl.options\" chart-data=\"$ctrl.data.data\" chart-colors=\"$ctrl.data.colors\"\n            chart-series=\"$ctrl.data.series\" chart-labels=\"$ctrl.xlabels\">\n        </canvas>\n    </div>\n    <div class=\"legend-container\" data-ng-style=\"$ctrl.legendStyle\"></div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/authorized/newDashBoard/components/graphs/line/line.html
// module id = 1753
// module chunks = 0